import React, { Suspense } from "react";
import { IRobot } from "../store/robot/types";
import { useSelector } from "react-redux";
import { IRootState } from "../store/store";
import { RobotSet } from "../store/search/types";
import Image from "./Image";
import Tilt from "react-tilt";
import ErrorBoundary from "./ErrorBoundary";

export interface ICardProps {
  robot: IRobot;
}

const Card: React.FC<ICardProps> = ({ robot }): React.ReactElement => {
  const { id, name, email } = robot;
  const set: RobotSet = useSelector((s: IRootState) => s.search.set);
  return (
    <Tilt
      className="tc bg-dark-gray dib pa3 ma3 grow bw2 shadow-5"
      options={{ max: 55 }}
    >
      <ErrorBoundary
        fallback={<p className="tc light-red b">Unable to load image</p>}
      >
        <Suspense fallback={<p className="white f4">Loading robot image</p>}>
          <Image
            src={`https://robohash.org/${id}?set=${set}&size=190x190`}
            alt="Robot"
          />
        </Suspense>
      </ErrorBoundary>

      <div className="white">
        <h2>{name}</h2>
        <p>{email}</p>
      </div>
    </Tilt>
  );
};

export default Card;
